// =============================================================================
// Máscaras de input — só formatam pra exibição; o valor "cru" guardado é
// sempre só dígitos (evita sujar cadastro). Centrão · Portal Arquitetos.
// =============================================================================

// Mantém só dígitos de uma string.
export function soDigitos(v) {
  return String(v || '').replace(/\D/g, '');
}

// CPF (000.000.000-00) ou CNPJ (00.000.000/0000-00), conforme a quantidade de
// dígitos. Aceita entrada já mascarada ou crua. Limita a 14 dígitos (CNPJ).
export function mascaraCpfCnpj(valor) {
  const d = soDigitos(valor).slice(0, 14);
  if (d.length <= 11) {
    if (d.length <= 3) return d;
    if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
    if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
    return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9, 11)}`;
  }
  if (d.length <= 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12, 14)}`;
}

// Telefone BR com DDD: celular (00) 00000-0000 (11 díg.) ou fixo (00) 0000-0000
// (10 díg.). Limita a 11 dígitos. Aceita entrada já mascarada ou crua.
export function mascaraTelefone(valor) {
  const d = soDigitos(valor).slice(0, 11);
  if (d.length === 0) return '';
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7, 11)}`;
}

// Valida telefone BR: 10 (fixo) ou 11 (celular) dígitos.
export function telefoneValido(valor) {
  const d = soDigitos(valor);
  return d.length === 10 || d.length === 11;
}
